export const QUICK_FILTER_NAMES = ['openNow', 'fuel', 'evCharger', 'truckServices', 'loyaltyPrograms'] as const;

export type QuickFilterName = (typeof QUICK_FILTER_NAMES)[number];

export interface QuickFilterConfig {
  id: QuickFilterName;
  translationKey: string;
  filterType: 'openNow' | 'service' | 'allFuels' | 'servicePattern' | 'loyaltyPrograms';
  filterValues: string[];
}
export const OPEN_NOW_FILTER = {
  id: 'openNow',
  translationKey: 'openNow',
  filterType: 'openNow',
  filterValues: [],
} as const satisfies QuickFilterConfig;

export const FUEL_FILTER = {
  id: 'fuel',
  translationKey: 'fuel',
  filterType: 'allFuels',
  filterValues: [],
} as const satisfies QuickFilterConfig;

export const EV_CHARGER_FILTER = {
  id: 'evCharger',
  translationKey: 'evCharger',
  filterType: 'service',
  filterValues: ['NA_EVCHARGING'],
} as const satisfies QuickFilterConfig;

export const TRUCK_SERVICES_FILTER = {
  id: 'truckServices',
  translationKey: 'truckServices',
  filterType: 'servicePattern',
  filterValues: ['TRUCK'],
} as const satisfies QuickFilterConfig;

export const LOYALTY_PROGRAM_FILTER = {
  id: 'loyaltyPrograms',
  translationKey: 'loyaltyPrograms',
  filterType: 'loyaltyPrograms',
  filterValues: ['innerCircle', 'extra', 'rewardClub'],
} as const satisfies QuickFilterConfig;

export const QUICK_FILTERS: QuickFilterConfig[] = [
  OPEN_NOW_FILTER,
  FUEL_FILTER,
  EV_CHARGER_FILTER,
  TRUCK_SERVICES_FILTER,
  LOYALTY_PROGRAM_FILTER,
];
